import axios from 'axios';

const { CORE_API_URL } = require('../utility/Constant');

export const getExternalKey = () =>
  axios.post(`${CORE_API_URL}/auth/guest`, undefined, { headers: { Authorization: 'No-Need-Authorization' }
});
export const getProviderDetail = id => axios.get(`/appointment/v1/providers/${id}`);
